import React, { useEffect, useState } from "react";

const MedicalPartnerListInlineTextField = ({ ariaLabel, defaultValue, onCommit, disabled = false, placeholder = "" }) => {
  const [val, setVal] = useState(() => (defaultValue != null ? String(defaultValue) : ""));

  useEffect(() => {
    setVal(defaultValue != null ? String(defaultValue) : "");
  }, [defaultValue]);

  const commit = () => {
    if (disabled) return;
    const next = String(val).trim();
    const prev = defaultValue != null ? String(defaultValue).trim() : "";
    if (next === prev) return;
    onCommit(next);
  };

  return (
    <input
      type="text"
      className="form-control form-control-sm border-0 bg-transparent px-1 py-1 medical-partner-list__inline-input"
      value={val}
      placeholder={placeholder}
      aria-label={ariaLabel}
      disabled={disabled}
      onChange={(e) => setVal(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          e.currentTarget.blur();
        }
      }}
      onClick={(e) => e.stopPropagation()}
    />
  );
};

export default MedicalPartnerListInlineTextField;
